import styled from 'styled-components';
import {
  brightBlue,
  red,
  gradientBackground,
} from '../../../utils/theme';
import { tablet } from '../../../utils/breakpoints';

const HEIGHT = 'auto';
const WIDTH = '1500px';

export const HeroCarouselWrapper = styled.div`
  max-height: ${HEIGHT};
  ${gradientBackground}
`;

export const HeroCarouselNewsWrapper = styled(HeroCarouselWrapper)`
  max-height: none;
  min-height: 450px;
  
  @media (max-width: ${tablet.max}px) {
    min-height: 0;
  }
`;

export const HeroCarouselInner = styled.div`
  max-height: ${HEIGHT};
  max-width: ${WIDTH};
  margin: 0 auto;
  position: relative;
  z-index: 1;

  .slick-dots {
    z-index: 1;
    bottom: -30px;
  }
  .slick-dots li button:before {
    background: ${brightBlue};
  }

  .slick-dots li.slick-active button:before {
    background: ${red};
  }

  > div {
    position: relative;
  }
`;

export const HeroCarouselNewsInner = styled(HeroCarouselInner)`
  max-width: 1500px;
  max-height: none;
  position: relative;
  z-index: 1;
  
  &>div{
    max-width: 100%;
    max-height: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/components/hero-carousel/styles/heroCarouselWrapper.style.js